import { render, staticRenderFns } from "./collectRecord.vue?vue&type=template&id=6d0c47f6&scoped=true"
import script from "./collectRecord.vue?vue&type=script&lang=js"
export * from "./collectRecord.vue?vue&type=script&lang=js"
import style0 from "./collectRecord.vue?vue&type=style&index=0&id=6d0c47f6&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d0c47f6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/Test-五域创客/jh-5eck-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6d0c47f6')) {
      api.createRecord('6d0c47f6', component.options)
    } else {
      api.reload('6d0c47f6', component.options)
    }
    module.hot.accept("./collectRecord.vue?vue&type=template&id=6d0c47f6&scoped=true", function () {
      api.rerender('6d0c47f6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/platformManage/components/collectRecord.vue"
export default component.exports